module.exports = __webpack_public_path__ + "img/chevron-right.d27b8af5.svg";